export default {
    "ARTIST": {
        "ARTIST": "Artist",
        "ARTISTS": "Artists",
        "NAME": "Name",
        "CATEGORY": "Category",
        "CATEGORIES": "Categories",
        "FB_ID": "Facebook ID",
    }
}



// WEBPACK FOOTER //
// ./src/i18n/messages/en/artist.js